import { Mail, Phone, MapPin } from "lucide-react";
import { BBC_LOGO_URL } from "@/lib/brand";

export default function Footer({ content, location, services = [] }) {
  const tag = content?.tagline || "Preaching Christ. Serving the community.";
  const copyright = content?.copyright || "© Bible Baptist Church Barani. All Rights Reserved.";
  const email = (location?.email || "").replace(",com", ".com");
  return (
    <footer data-testid="site-footer" className="bg-[#1C201E] text-[#E5E0D8] mt-24 relative">
      <div className="noise-overlay" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 relative">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-[#FAF9F6] flex items-center justify-center overflow-hidden">
                <img src={BBC_LOGO_URL} alt="BBC Barani seal" className="w-10 h-10 object-contain" />
              </div>
              <span className="font-serif-display text-2xl">BBC Barani</span>
            </div>
            <p className="text-sm text-[#B3B8B4] leading-relaxed">{tag}</p>
          </div>

          <div>
            <h4 className="font-serif-display text-xl mb-4">Visit Us</h4>
            <ul className="space-y-3 text-sm text-[#B3B8B4]">
              <li className="flex gap-3"><MapPin aria-hidden="true" className="w-4 h-4 mt-1 text-[#D4A373] shrink-0" /><span>{location?.address}</span></li>
              {location?.phone && <li className="flex gap-3"><Phone aria-hidden="true" className="w-4 h-4 mt-1 text-[#D4A373] shrink-0" /><a className="rounded-sm hover:text-white" href={`tel:${location.phone}`}>{location.phone}</a></li>}
              {email && <li className="flex gap-3"><Mail aria-hidden="true" className="w-4 h-4 mt-1 text-[#D4A373] shrink-0" /><a className="rounded-sm break-all hover:text-white" href={`mailto:${email}`}>{email}</a></li>}
            </ul>
          </div>

          <div>
            <h4 className="font-serif-display text-xl mb-4">Service Times</h4>
            <ul className="space-y-3 text-sm text-[#B3B8B4]">
              {services.length ? services.map((service, index) => (
                <li key={`${service.day}-${service.time}-${index}`}>
                  <span className="text-[#E5E0D8]">{service.day}</span> · {service.time}<span className="block text-xs mt-0.5">{service.name}</span>
                </li>
              )) : <><li>Sunday services</li><li>Wednesday prayer meeting</li></>}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-xs text-[#8A8F8B]">
          {copyright}
        </div>
      </div>
    </footer>
  );
}
